import React from 'react'
import Step1 from './Forms/Step1'
import Step2 from './Forms/Step2'
import Step3 from './Forms/Step3'
import Step4 from './Forms/Step4'
import Icon from './Icon'
import List from './List'

function StepContents({ block }) {
    return (
        <>  
            <div className="flex items-center pl-[50px] gap-x-5 lg:flex-row-reverse lg:justify-center lg:gap-x-14">
                {block.list && <List list={block.list}/>}
                {block.icon && <Icon icon={block.icon}/>}
            </div>
            {block.id === 1 && <Step1 />}
            {block.id === 2 && <Step2 />}
            {block.id === 3 && <Step3 />}
            {block.id === 4 && <Step4 />}
        </>
    )

}

export default StepContents